import { createRouter, createWebHistory } from "vue-router";
import LoginView from "@/views/LoginView.vue";

const routes = [
  {
    path: "/",
    name: "LoginView",
    component: LoginView,
  },
  {
    path: "/home",
    name: "HomeView",
    component: () =>
      import("../views/HomeView.vue"),
  },
  {
    path: "/table",
    name: "table",
    component: () =>
      import("../views/TableView.vue"),
  },
  {
    path: "/bills",
    name: "bills",
    component: () =>
      import("../views/BillsView.vue"),
  },
  {
    path: "/settings",
    name: "settings",
    component: () =>
      import("../views/SettingsView.vue"),
  },
  {
    path: "/settings/change-password",
    name: "changepassword",
    component: () =>
      import("../views/ChangePasswordView.vue"),
  },
  {
    path: "/attendanceanddeparture",
    name: "AttendanceAndDepartureView",
    component: () =>
      import("../views/AttendanceAndDepartureView.vue"),
  },
  {
    path: "/attendanceanddeparture/AttendanceRecords",
    name: "AttendanceRecordsView",
    component: () =>
      import("../views/AttendanceRecordsView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
